var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"splash"},[_c('h1',[_vm._v(_vm._s(_vm.translation.STR_WELCOME))]),_c('h2',[_vm._v(_vm._s(_vm.translation.STR_WELCOME2))])])])}
var staticRenderFns = []

export { render, staticRenderFns }